/**
 * ------------------------------------------------------------
 * Purpose        : "Why Say Yes" cards for /lp-nw/mba-rajasthan (static, not CMS)
 * ------------------------------------------------------------
 */

import type { WhySayYesItem } from "@/components/sections/WhySayYesNewTemplete/types";

const ICON = { type: "IMG", width: 52, height: 52 } as const;

export const RAJASTHAN_WHY_US_ITEMS: WhySayYesItem[] = [
  {
    heading: "NAAC A+ Accreditation",
    subHeading:
      "Amity University Rajasthan is accredited with an A+ grade by the National Assessment and Accreditation Council (NAAC).",
    src: "https://static.amityonline.com/_s/naac_1_de0fe2ade4.webp",
    type: "PNG",
    width: 97,
    height: 72,
    imageHeight: 72,
  },
  {
    heading: "QS Southern Asia Rankings 2026",
    subHeading:
      "Ranked amongst the top 2 private universities in Rajasthan by QS World University Rankings — Southern Asia 2026.",
    src: "https://static.amityonline.com/_s/QS_Southern_Asia_University_Rankings_2026_4abc016133.webp",
    type: "PNG",
    width: 184,
    height: 72,
    imageHeight: 72,
  },
  {
    heading: "THE Asia Rankings 2026",
    subHeading:
      "Ranked #1 private university in Rajasthan by Times Higher Education World University Rankings 2026 — Asia.",
    src: "https://static.amityonline.com/_s/ranking_12dd531c59.webp",
    type: "PNG",
    width: 199,
    height: 72,
    imageHeight: 72,
  },
  {
    heading: "THE Sustainability Impact Ratings 2026",
    subHeading:
      "Ranked amongst the top 2 private and government universities in Rajasthan by Times Higher Education Sustainability Impact Ratings 2026.",
    src: "https://static.amityonline.com/_s/times_513239b0ca.webp",
    type: "PNG",
    width: 177,
    height: 55,
    imageHeight: 55,
  },
  {
    heading: "UGC Entitled",
    subHeading:
      "Online degree programs entitled by the University Grants Commission (UGC).",
    src: "https://static.amityonline.com/_s/ugc_logo_c1a14fcad7.webp",
    type: "PNG",
    width: 52,
    height: 57,
  },
  {
    heading: "1:1 Industry Mentorship",
    subHeading:
      "Gain tailored industry insights to develop your skills and strengthen your professional perspective.",
    src: "https://static.amityonline.com/_s/benefit_mentorship_41f41ac80c.svg",
    ...ICON,
  },
  {
    heading: "Mobile-First Learning",
    subHeading:
      "Learn on the go with a platform designed for seamless mobile access and intuitive navigation.",
    src: "https://static.amityonline.com/_s/benefit_mobile_learning_67bf62f544.svg",
    ...ICON,
  },
  {
    heading: "Dedicated Academic Advisor",
    subHeading:
      "Receive expert guidance from professionals who support you through your academic journey.",
    src: "https://static.amityonline.com/_s/benefit_academic_advisor_358e580b18.svg",
    ...ICON,
  },
  {
    heading: "Industry-Aligned Curriculum",
    subHeading:
      "Build relevant management knowledge through a curriculum aligned with industry requirements.",
    src: "https://static.amityonline.com/_s/benefit_curriculum_420b81786e.svg",
    ...ICON,
  },
  {
    heading: "Amigo App",
    subHeading:
      "The Amigo app makes learning seamless and mobile — attend live classes, track progress, access materials, and more on your schedule.",
    src: "https://static.amityonline.com/_s/benefit_mobile_learning_1_dba3bdffc3.svg",
    ...ICON,
  },
  {
    heading: "Interactive Faculty Sessions",
    subHeading:
      "Engage with faculty through interactive sessions and dedicated doubt-clearing opportunities.",
    src: "https://static.amityonline.com/_s/benefit_faculty_sessions_0402ab1a2d.svg",
    ...ICON,
  },
  {
    heading: "AI-Powered Learning",
    subHeading:
      "Simplify success with an all-in-one intuitive platform: instant AI summaries, a fully immersive learning environment, and a built-in note taker.",
    src: "https://static.amityonline.com/_s/ai_a18a9ddcf7.webp",
    ...ICON,
  },
];
